module.exports = __webpack_public_path__ + "static/media/child_profile_empty.a0f3383a.svg";